import { useLocation, useRouteMatch } from 'react-router-dom';
import urljoin from 'url-join';

import useClaimSidebarTabs from '~/components/ClaimPage/hooks/useClaimSideBarTabs';
import { useCliveClaimContext } from '~/components/SystemConfiguration/CliveConfiguration/CliveClaimContext';

import type { ClaimSideBarTab, SideBarKey } from '../useClaimSideBarTabs/utils';

interface UseClaimActiveTabReturn {
  activeTab: ClaimSideBarTab<SideBarKey> | undefined;
  shouldDisplayEmbeddedChat: boolean;
}

const useClaimActiveTab = (): UseClaimActiveTabReturn => {
  const location = useLocation();
  const match = useRouteMatch();
  const { isClaimChatEnabled } = useCliveClaimContext();
  const tabs = useClaimSidebarTabs();

  const activeTab = tabs.find(({ url }) => location.pathname.startsWith(urljoin(match.url, url)));

  const shouldDisplayEmbeddedChat = isClaimChatEnabled && !!activeTab?.shouldDisplayEmbeddedChat;

  return {
    activeTab,
    shouldDisplayEmbeddedChat,
  };
};

export default useClaimActiveTab;
